import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as CustomActions from './check-bilanci.actions';
import { CheckBilanciPartialState } from './check-bilanci.reducer';
import * as CustomSelectors from './check-bilanci.selectors';

@Injectable({
  providedIn: 'root',
})
export class CheckBilanciFacade {
  esercizioChecked$ = this.store.pipe(
    select(CustomSelectors.selectEsercizioChecked)
  );

  esercizioClosed$ = this.store.pipe(
    select(CustomSelectors.selectEsercizioClosed)
  );

  consolidatoChecked$ = this.store.pipe(
    select(CustomSelectors.selectConsolidatoChecked)
  );

  consolidatoExists$ = this.store.pipe(
    select(CustomSelectors.selectConsolidatoExists)
  );

  consolidatoClosed$ = this.store.pipe(
    select(CustomSelectors.selectConsolidatoClosed)
  );

  consolidatoEnteId$ = this.store.pipe(
    select(CustomSelectors.selectConsolidatoEnteId)
  );

  consolidatoAnno$ = this.store.pipe(
    select(CustomSelectors.selectConsolidatoAnno)
  );

  esercizioEnteId$ = this.store.pipe(
    select(CustomSelectors.selectEsercizioEnteId)
  );

  esercizioAnno$ = this.store.pipe(select(CustomSelectors.selectEsercizioAnno));

  riepilogoChecked$ = this.store.pipe(
    select(CustomSelectors.selectRiepilogoChecked)
  );

  datiRiepilogoModificati$ = this.store.pipe(
    select(CustomSelectors.selectDatiRiepilogoModificati)
  );

  constructor(private store: Store<CheckBilanciPartialState>) {}

  checkEsercizioChiuso() {
    this.store.dispatch(CustomActions.checkEsercizioChiuso());
  }

  checkConsolidato(anno: number | undefined = undefined) {
    this.store.dispatch(CustomActions.checkConsolidato({ anno }));
  }

  checkDatiRiepilogoModificati() {
    this.store.dispatch(CustomActions.checkDatiRiepilogoModificati());
  }
}
